import {on} from "../jsbase/events";
var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.attr('data-id');
                var showAddPosition = ($rowElem.is('.node,.leaf[data-childs="0"]')
                        && !$rowElem.is('[data-depth="1"],[data-depth="2"]'))
                        || $rowElem.is('tr[data-aid="6"],tr[data-aid="7"],tr[data-aid="8"],tr.own-pos');
                var isPricePosition = $rowElem.is('[data-type="priceposition"]');
                var canAddBkpHere = $rowElem.attr('data-bkp').length >= 1
                    && $rowElem.attr('data-bkp') !== 'Z'
                    && $rowElem.attr('data-bkp').length <= 4;

                // console.log("data-aid", $rowElem.attr('data-aid'));
                // console.log("data-childs", $rowElem.attr('data-childs'));
                // console.log("showAddPosition",showAddPosition, $rowElem.is('.node,.leaf[data-childs="0"]'), !$rowElem.is('[data-depth="1"],[data-depth="2"]'), $rowElem.is('tr[data-aid="6"],tr[data-aid="7"],tr[data-aid="8"],tr.own-pos[data-childs="0"]'));
                // console.log("canAddBkpHere",canAddBkpHere, $rowElem.attr('data-bkp').length, $rowElem.attr('data-bkp'), $rowElem.attr('data-bkp').length);

                return {
                    id: rowId,
                    $el: $rowElem,
                    isNode: $rowElem.is('.node'),
                    isLeaf: $rowElem.is('.leaf'),
                    isCompanyPosition: $rowElem.is('.own-pos'),
                    isPricePosition: isPricePosition,
                    level: $rowElem.attr('data-depth'),
                    showAddTreePosition: showAddPosition && !isPricePosition,
                    showAddBkpPosition: showAddPosition && canAddBkpHere,
                    showAddPosition: showAddPosition && !isPricePosition,
                };
            },
            actions: {
                extendPosition: {
                    name: 'öffnen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-plus',
                    onClick: this.extendPosition,
                    isShown: function(row) {
                        return row.isPricePosition;
                    }
                },
                extendToLevel4: {
                    name: 'BKP 1-4 Stelle öffnen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-text-indent-left',
                    onClick: this.extendToLevel4,
                    isShown: function(row) {
                        return row.level == 1;
                    }
                },
                renamePosition: {
                    name: 'Eigenschaften der Position',
                    classNames: 'dropdown-item border-top',
                    iconClass: 'bi-sliders',
                    onClick: this.renamePosition,
                },
                exportPosition: {
                    name: 'Excel Export',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-clipboard',
                    onClick: this.exportPosition,
                    isShown: function(row) {
                        return false; // row.isCompanyPosition;
                    }
                },
                addBkpTreePosition: {
                    name: 'BKP Hauptposition hinzufügen',
                    classNames: 'dropdown-item border-top',
                    iconClass: 'bi-folder-fill',
                    onClick: this.addBkpTreePosition,
                    isShown: function(row) {
                        return row.showAddBkpPosition;
                    }
                },
                addTreePosition: {
                    name: 'Hauptposition hinzufügen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-folder-fill',
                    onClick: this.addTreePosition,
                    isShown: function(row) {
                        return row.showAddTreePosition;
                    }
                },
                addPosition: {
                    name: 'Preisposition hinzufügen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-list-ul',
                    onClick: this.addPosition,
                    isShown: function(row) {
                        return row.showAddPosition;
                    }
                },
                addSumPosition: {
                    name: 'Preisposition "Prozentanteil von"',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-percentage-list',
                    onClick: this.addSumPosition,
                    isShown: function(row) {
                        return row.showAddPosition;
                    }
                },
                copyPosition: {
                    name: 'Position duplizieren',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-clipboard',
                    onClick: this.copyPosition,
                    isShown: function(row) {
                        if (authentication.isAdminOrLoginAs) {
                            return true;
                        }
                        return row.isLeaf;
                    }
                },
                deletePosition: {
                    name: 'Position löschen',
                    classNames: 'dropdown-item',
                    iconClass: 'bi-trash text-danger',
                    onClick: this.deletePosition,
                    isShown: function(row) {
                        return row.isCompanyPosition;
                    }
                },
            },
        });
    },

    events: [{
        name: 'calculation.part-loaded',
        el() {
            return document;
        },
        handler(ev) {
            $.each(ev.detail.container, (i, cel) => {
                if (cel) {
                    cel.querySelectorAll('.btn-context-click').forEach((el) => {
                        on(el, 'click', (cev) => {
                            cev.preventDefault();
                            cev.stopPropagation();
                            var rowEl = $(cev.target).closest(this.selector);
                            this.menu.open(rowEl, cev.detail.originalEvent || cev);
                        });
                    });
                }
            });
        },
    }],

    methods: {
        extendPosition(row) {
            if (row.id) {
                console.log('extendPosition', row);
                if (row.isPricePosition) {
                    row.$el.addClass('slidein-active');
                    slidein.openUrl('/Project/PositionPriceDetail/' + row.id, function (element) {
                        project.initPositionDetails(element);
                    });
                } else {
                    project.openSubPositionsPart(row.$el);
                }
            }
        },
        extendToLevel4(row) {
            if (row.$el.is('.node')) {
                project.openLevel1To4(row.$el.attr('data-bkp'), false);
            }
        },
        addTreePosition(row) {
            if (row.id) {
                project.createNewPosition(null, row.$el, false);
            }
        },
        addBkpTreePosition(row) {
            if (row.id) {
                project.createNewPosition(null, row.$el, false, true);
            }
        },
        addPosition(row) {
            if (row.id) {
                project.createNewPosition(null, row.$el, true);
            }
        },
        addSumPosition(row) {
            if (row.id) {
                project.createNewPosition(null, row.$el, true, false, true);
            }
        },
        renamePosition(row) {
            if (row.id) {
                project.renamePosition(null, row.$el);
            }
        },
        copyPosition(row) {
            if (row.id) {
                project.copyPosition(null, row.$el);
            }
        },
        exportPosition(row) {
            if (row.id) {
                project.exportPosition(null, row.$el);
            }
        },
        deletePosition(row) {
            if (row.id) {
                project.deletePosition(null, row.$el);
            }
        },
    },

}
